export default __webpack_public_path__ + "static/logo__white-7fca67cfc28d8b142b226e225face25f.png";